export const CHARGER_SELECTED = "CHARGER_SELECTED";

export const UPDATE_CHARGER_DATA = "UPDATE_CHARGER_DATA"

export const ADD_CHARGER_IDS = "ADD_CHARGER_IDS";

export const RESET_CHARGER = "RESET_CHARGER"

export const UPDATE_CHARGER_FILTER = "UPDATE_CHARGER_FILTER";

export const UPDATE_FILTER_PARAM = "UPDATE_FILTER_PARAM";

export const UPDATE_FILTER_STATUS = "UPDATE_FILTER_STATUS";

export const RESET_CHARGER_FILTER = "RESET_CHARGER_FILTER"
